<template>
  <v-card-text>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex md8 xs12>
          <v-text-field label="First Name" v-model="user.firstName" readonly hide-details></v-text-field>
        </v-flex>
        <v-flex md4 xs12>
          <v-text-field label="Last Name" v-model="user.lastName" readonly hide-details></v-text-field>
        </v-flex>
        <v-flex md6 xs12>
          <v-text-field label="Mobile No." v-model="user.mobileNo" readonly hide-details></v-text-field>
        </v-flex>
        <v-flex md6 xs12>
          <v-text-field label="Office/Ext No." v-model="user.officeNo" readonly hide-details></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field label="Email" v-model="user.email" readonly hide-details></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field label="User Reference ID" v-model="user.usrRefId" readonly hide-details></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-subheader>User Branches</v-subheader>
          <div class="d-flex flex-wrap chip-group">
            <v-chip v-for="(branch, index) in displayBranches"  :color="index === 0? 'primary' : ''" :key="branch">{{branch}}</v-chip>
          </div>
        </v-flex>
        <v-flex xs12 v-if="user.intermediary">
          <v-text-field label="Intermediary" v-model="user.intermediaryName" readonly hide-details></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-subheader>Access Roles</v-subheader>
          <div class="d-flex flex-wrap chip-group">
            <v-chip v-for="role in displayRoles" :key="role">{{role}}</v-chip>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card-text>
</template>

<script>
export default {
  data() {
    return {}
  },
  computed: {
    displayRoles() {
      const result = []
      if (this.user.superAdmin) {
        result.push('Super Administrator')
      } else {
        if (this.user.roles && this.user.roles.length > 0) {
          this.user.roles.map(role => {
            const desc = this.roles.filter(descRole => descRole.value === role)
            if (desc && desc.length > 0) {
              result.push(desc[0].label)
            }
          })
        }
      }
      return result
    },
    displayBranches() {
      const result = []
      if (this.user.usrBranches && this.user.usrBranches.length > 0) {
        this.user.usrBranches.map(branch => {
          const desc = this.usrBranches.filter(descBranch => descBranch.value === branch)
          if (desc && desc.length > 0) {
            result.push(desc[0].label)
          }
        })
      }
      return result
    }
  },
  props: {
    user: {
      type: Object,
      default: () => { }
    },
    roles: {
      type: Array,
      default: () => []
    },
    usrBranches: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss">
.chip-group {
  gap: 8px;
}
</style>
